import statistics from '@/api/apiSferest/services/statistics'

export const getDataSets = ({getters, commit}, value) => {
  return new Promise((resolve, reject) => {
    let params = {
      ...getters['apificate']
    }
    if (!value) delete params.period
    statistics.get(params)
    .then((res) => {
      commit('SET_LABELS', res.data.labels)
      commit('SET_DATASETS', res.data.dataset)
      resolve()
    })
  })
}
